// extracted by mini-css-extract-plugin
export default {"table-wrapper":"vmnRy7SNzMoa5LWv6o3C","table-fixed":"lxr1cVhKUzF2apjuQjqb","loading":"vAKep584U1zT0TlMvn6r"};